import { render, staticRenderFns } from "./_Pinnedorganization.vue?vue&type=template&id=039f600a&scoped=true"
import script from "./_Pinnedorganization.vue?vue&type=script&lang=js"
export * from "./_Pinnedorganization.vue?vue&type=script&lang=js"
import style0 from "./_Pinnedorganization.vue?vue&type=style&index=0&id=039f600a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f600a",
  null
  
)

export default component.exports